import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { GoogleAdWordsObjectDataset } from 'app/model/dataset/google-adwords.dataset';
import { CopySourceMode, TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'GoogleAdWordsSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(GoogleAdWordsObjectDataset) }
})
export class GoogleAdWordsCopySource extends TabularCopySource {
     // UI model only
     public mode: CopySourceMode = 'query';
}
